import {
  CwsButton,
  CwsGrid,
  CwsGridCol,
  CwsGridRow,
  CwsIcon,
  CwsSelect,
  CwsSelectOption,
  CwsLabel,
  CwsSection,
  CwsSpan,
} from '@components/cws'
import s from './Parameter.module.scss'
import type { KeyLabelOption } from '@ui/components/Selector/Selector'
import type { Dispatch, FC, SetStateAction } from 'react'
import { useContext, useEffect, useState } from 'react'
import { useTranslate } from '@hooks/useTranslation'
import type { OrderKey } from '@model/product/ProductSearchResult'
import { PerPage } from '@components/product/Parameter/PerPage'
import { localStorageHelper } from '@utils/localStorageHelper'
import { device600, useResize } from '@ui/hooks/useResize'
// @ts-ignore
import { CwsAlignerContext } from 'cms-web-styleguide/dist/components/CwsAligner/CwsAligner'
const SORTING_STORY = 'SORTING_STORY'
export interface ParameterProps {
  label: string
  itemsPerPageValue?: string
  setItemsPerPageValue?: Dispatch<SetStateAction<string>>
  options: KeyLabelOption[]
  setIsSidePanelOpen?: Dispatch<SetStateAction<boolean>>
  isSidePanelOpen?: boolean
  handleSelect(arg0: string): void
  isCategoryPage?: boolean
  filterButtonHandler?: Dispatch<SetStateAction<'filters' | 'sort' | null>>
}

const Parameter: FC<ParameterProps> = (props) => {
  const {
    label,
    options,
    handleSelect,
    setIsSidePanelOpen,
    itemsPerPageValue,
    setItemsPerPageValue,
    isSidePanelOpen,
    isCategoryPage,
    filterButtonHandler,
  } = props
  const { deviceSize } = useResize()
  const isMobile = deviceSize > device600
  const valueStory = localStorageHelper.get(SORTING_STORY)
  const initialValue = valueStory || (options.length && options[0].key) || 'none'
  const [value, setValue] = useState<OrderKey>(initialValue as OrderKey)
  // @ts-ignore
  const { triggerUpdate } = useContext(CwsAlignerContext)

  useEffect(() => {
    if (value) {
      localStorageHelper.set(SORTING_STORY, value)
      handleSelect(value)
    }
  }, [value])
  function handleFilterDesktop() {
    if (setIsSidePanelOpen) setIsSidePanelOpen((prevState) => !prevState)
    triggerUpdate()
  }
  const { translate } = useTranslate()
  return (
    <CwsSection>
      <CwsGridRow noGutter verticalAlign="center">
        <CwsGridCol col="12">
          <CwsGridRow verticalAlign="center">
            <CwsGridCol col="auto" sm="4" className="cws-mb-0 cws-mt-20">
              {setIsSidePanelOpen && isCategoryPage && (
                <CwsButton size="medium" variant="secondary" onClick={handleFilterDesktop}>
                  <CwsSection className="flex items-center justify-between">
                    <CwsIcon size="16px" icon="funnel" onClick={filterButtonHandler} />
                    {isMobile && (
                      <CwsSpan className="cws-pl-4">
                        {isSidePanelOpen
                          ? translate('w2.products.page.filter.hide')
                          : translate('w2.products.page.filter.show')}
                      </CwsSpan>
                    )}
                  </CwsSection>
                </CwsButton>
              )}
            </CwsGridCol>

            <CwsGridCol className="cws-g-tiny" col="fluid" sm="8">
              <CwsGridRow justifyContent={!isMobile ? 'left' : 'right'} verticalAlign="center">
                <CwsGridCol col="4" lg={isSidePanelOpen ? 'auto' : '5'} md="auto" sm={'6'}>
                  {itemsPerPageValue && setItemsPerPageValue && (
                    <>
                      <CwsLabel className="truncate line-clamp-2">
                        {`${translate('w2.category.count.items')} / ${translate('w2.category.count.page')} :`}
                      </CwsLabel>
                      <PerPage {...{ setItemsPerPageValue, itemsPerPageValue, isSidePanelOpen }} />
                    </>
                  )}
                </CwsGridCol>
                <CwsGridCol col="7" lg={isSidePanelOpen ? '5' : '5'} md={isSidePanelOpen ? '5' : 'auto'} sm={'6'}>
                  <CwsLabel className="truncate line-clamp-2">{`${label}: `}</CwsLabel>
                  <CwsSelect
                    className={s.selectWrapper}
                    value={value}
                    onChange={setValue}
                    id="category-items-sort"
                    label={`${label}: `}
                  >
                    {options.map(({ label, translationKey, key }) => (
                      <CwsSelectOption
                        key={key}
                        value={key}
                        title={translationKey ? translate(translationKey) : label}
                      />
                    ))}
                  </CwsSelect>
                </CwsGridCol>
              </CwsGridRow>
            </CwsGridCol>
          </CwsGridRow>
        </CwsGridCol>
      </CwsGridRow>
    </CwsSection>
  )
}

export default Parameter
